/**
 * Shared offline helpers for all event forms.
 * Provides: search animal (API or local cache), submit (API or queue).
 */
import { searchAnimalLocal, addPendingOp } from './offlineDB';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const getToken = () => localStorage.getItem('token');
const authHeaders = () => ({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${getToken()}` });

/**
 * Search animal by VID or IDE — online: API, offline: local cache.
 * Returns { animal, source } on single match,
 * { results, source } on multiple matches,
 * throws on no match.
 */
export async function buscarAnimalOffline(query, establecimientoId) {
  if (navigator.onLine) {
    try {
      const res = await axios.get(`${BACKEND_URL}/api/animales/buscar/rfid/${encodeURIComponent(query)}`, {
        params: { establecimiento_id: establecimientoId },
        headers: authHeaders(),
      });
      return { animal: res.data, source: 'server' };
    } catch {
      // Fall through to local search
    }
  }
  // Offline or API failed → local cache
  const results = await searchAnimalLocal(query, establecimientoId);
  if (results.length === 1) return { animal: results[0], source: 'cache' };
  if (results.length > 1) return { animal: results[0], results, source: 'cache' };
  throw new Error('Animal no encontrado');
}

/**
 * Submit event form — online: API, offline: queue to IndexedDB.
 * Returns { online: bool, data?, message? }
 */
export async function submitOffline(url, payload) {
  if (navigator.onLine) {
    try {
      const res = await axios.post(`${BACKEND_URL}${url}`, payload, { headers: authHeaders() });
      return { online: true, data: res.data };
    } catch (err) {
      throw err;
    }
  }
  // Offline → queue. Strip /api prefix since sync engine uses api instance with baseURL /api
  const syncUrl = url.startsWith('/api') ? url.slice(4) : url;
  await addPendingOp({ method: 'POST', url: syncUrl, data: payload });
  return { online: false, message: 'GUARDADO LOCALMENTE — Se sincronizara al volver a tener internet.' };
}
